module.exports = __webpack_public_path__ + "static/media/magic-stick.cbc71c1c.svg";